import Vue, { CreateElement, VNode } from "vue";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { getContextModules, getComponent } from "@/lib/requireContextHelpers";
import { IntegrationModule } from "./types";

const modules = getContextModules<PaymentSystemPublic | null, IntegrationModule<any>>(
  require.context("./", true, /\.\/[a-zA-Z0-9]*\/index.ts/)
);

export default function(item: PaymentSystemPublic | null) {
  return getComponent<PaymentSystemPublic | null, IntegrationModule<any>>(modules, item, {
    paymentComponent: Vue.extend({
      render(h: CreateElement): VNode {
        return h();
      },
    }),
    purchase: () => {
      throw new Error("cant find integration to use");
    },
    subscribe: () => {
      throw new Error("cant find integration to use");
    },
    allowSaveCard: false,
    name: "",
  });
}
